import { faBath } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

function GridFeature({ cateogary }) {
    return (
        <div className="col-lg-3 col-6 grids-feature mt-2">
            <a href={`/cateogary/${cateogary}`}>
                <div className="area-box">
                    <FontAwesomeIcon icon={faBath} style={{ width: '10vh', height: '3vh' }} />
                    <h4 className="title-head">{cateogary.charAt(0).toUpperCase() + cateogary.slice(1)}</h4>
                </div>
            </a>
        </div>
    )
}

export default GridFeature
